import React from 'react';

import {AnalyticsVisualizationGradientDirection as GradientDirection} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';
import {getColumnOptionDatas} from 'insights/analytics-visualizations/configs/config-components/ConfigEditorUtils';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';

import {XYColumnEditor} from './config-components/XYSeriesColumnEditor';
import DropdownSelector from './form-components/DropdownSelector';
import {VisualizationConfigEditorComponentProps} from './VisualizationConfigEditorTypes';

type HeatmapParameters = ExtractByTypename<
  AnalyticsVisualization['parameters'],
  'AnalyticsVisualizationHeatmapParametersNode'
>;

export type HeatmapConfigEditorProps = VisualizationConfigEditorComponentProps<HeatmapParameters>;

type MetricParameter = Pick<HeatmapParameters, 'metricColumnName'>;

function MetricColumnEditor({
  columns,
  onUpdateParameters,
  parameters,
  useSystemNames,
  isDisabled = false,
}: VisualizationConfigEditorComponentProps<MetricParameter>): JSX.Element {
  function handleSelectMetricColumnName(metricColumnName: string): void {
    onUpdateParameters({metricColumnName});
  }
  return (
    <>
      <div className="u-input-spacing-top">
        <FieldLabel label="Metric" />
        <DropdownSelector
          allowNull={false}
          onChange={handleSelectMetricColumnName}
          searchable={true}
          selectedValue={parameters.metricColumnName}
          optionDatas={getColumnOptionDatas(columns, useSystemNames)}
          disabled={isDisabled}
        />
      </div>
    </>
  );
}

type GradientDirectionParameter = Pick<HeatmapParameters, 'gradientDirection'>;

function AscendingOrderCheckbox({
  onUpdateParameters,
  parameters,
  isDisabled,
}: VisualizationConfigEditorComponentProps<GradientDirectionParameter>): JSX.Element {
  return (
    <div className="u-input-spacing-top">
      <CheckboxInput
        id="ascending-order"
        label="Use ascending gradient"
        onChange={(e) => {
          onUpdateParameters({
            gradientDirection: e.target.checked
              ? GradientDirection.ASCENDING_METRIC_VALUES
              : GradientDirection.DESCENDING_METRIC_VALUES,
          });
        }}
        checked={parameters.gradientDirection === GradientDirection.ASCENDING_METRIC_VALUES}
        disabled={isDisabled}
      />
    </div>
  );
}

export default function HeatmapConfigEditor(props: HeatmapConfigEditorProps): JSX.Element {
  return (
    <>
      <XYColumnEditor {...props} fieldLabels={{x: 'Columns', y: 'Rows'}} reverseDisplayedAxes={true} />
      <MetricColumnEditor {...props} />
      <AscendingOrderCheckbox {...props} />
    </>
  );
}
